// Phase 2 §11: sub-admins are view-only. Missing/undefined role (accounts
// created before this field existed) is treated as main-admin — matches the
// backend's same fallback in requireMainAdmin.
export const isMainAdmin = (role?: string | null): boolean => role !== 'sub';
